import { defineStore } from "pinia";

let api_url = document.querySelector('meta[name="API_URL"]').content

export function getRoleText(role) {
    switch (role) {
        case 0:
            return ""
        case 1:
            return "super_administrator"
        case 2:
            return "progibox"
        case 3:
            return "tenant_administrator"
        case 4:
            return "tenant_progibox_administrator"
        case 5:
            return "tenant_progibox_reader"
    }   

}

export const useGlobalStore = defineStore('global', {
    state: () => ({
        api_url: api_url,
        old_path: "/",
        connected: true,
        login: null,
        role: null,
    }),
    getters: {
        isConnected: (state) => state.connected,
        getLogin: (state) => state.login,
        getRole: (state) => state.role,
    },
    actions: {
        setConnected(connected) {
            this.connected = connected
        },
        setLogin(login) {
            this.login = login
        },
        setRole(role) {
            this.role = role
        },
    },
})
